import React, { useEffect, useState } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';

const InviteTeammate = () => {
  const [email, setEmail] = useState('');
  const [userRole, setRole] = useState('user'); // State for the userRole, default is 'user'
  const [inviteStatus, setInviteStatus] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [teamMembers, setTeamMembers] = useState([]); // State for storing team members
  const [sendingInvite, setSendingInvite] = useState(false);

  const getTeamMembers = async () => {
    try {
      const session = await fetchAuthSession();
      const idToken = session.tokens.idToken.toString();
      const apiEndpoint = 'https://xjmn0g1tf5.execute-api.us-east-1.amazonaws.com/production/get-team-member';
      const response = await fetch(apiEndpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: idToken,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setTeamMembers(data.users); // Set team members
        setErrorMessage('');
      } else {
        const errorData = await response.json();
        setErrorMessage(`Error: ${errorData.message || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error fetching members:', error);
      setErrorMessage('Failed to fetch team members.');
    }
  };

  const handleInvite = async () => {

    setSendingInvite(true);

    try {
      // Fetch the current authentication session
      const session = await fetchAuthSession();
      const idToken = session.tokens.idToken.toString();
      const apiEndpoint = 'https://xjmn0g1tf5.execute-api.us-east-1.amazonaws.com/production/create-team-member';
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: idToken,
        },
        body: JSON.stringify({ email, userRole }), // Send email and userRole
      });


      if (response.ok) {
        setInviteStatus('Invitation sent successfully!');
        setErrorMessage('');
        getTeamMembers(); // Refresh team members after inviting
        setSendingInvite(false);
      } else {
        const errorData = await response.json();
        setErrorMessage(`Error: ${errorData.message || 'Unknown error'}`);
        setInviteStatus('');
        setSendingInvite(false);
      }
    } catch (error) {
      console.error('Error sending invitation:', error);
      setErrorMessage('Failed to send invitation. Please try again.');
      setInviteStatus('');
      setSendingInvite(false);
    }
  };

  useEffect(() => {
    getTeamMembers(); // Fetch team members on component load
  }, []);

  return (
    <div className="mt-[20px] flex flex-col items-center justify-center  bg-gray-100 px-4">
    <div className="w-full max-w-sm sm:max-w-md p-4 sm:p-8 bg-white shadow-md rounded-lg">
        <h2 className="text-xl sm:text-2xl font-bold text-center text-charmHover mb-4 sm:mb-6">
            Invite a Teammate
        </h2>

        <div className="mb-3 sm:mb-4">
            <label className="block text-base sm:text-lg text-gray-800 mb-1 sm:mb-2">Teammate's Email:</label>
            <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="block w-full px-3 sm:px-4 py-2 border border-neutral text-base sm:text-lg text-gray-900 focus:outline-none focus:border-charmOrange"
                placeholder="Enter email address"
                required
            />
        </div>

        {/* Dropdown for selecting userRole */}
        {/* <div className="mb-3 sm:mb-4">
            <label className="block text-base sm:text-lg text-gray-800 mb-1 sm:mb-2">Role:</label>
            <select
                value={userRole}
                onChange={(e) => setRole(e.target.value)}
                className="block w-full px-3 sm:px-4 py-2 border border-neutral text-base sm:text-lg text-gray-900 focus:outline-none focus:border-charmOrange"
            >
                <option value="user">User</option>
                <option value="root">Admin</option>
            </select>
        </div> */}

        {errorMessage && (
            <p className="text-red-500 text-sm sm:text-md mb-3 sm:mb-4">{errorMessage}</p>
        )}
        {inviteStatus && (
            <p className="text-green-500 text-sm sm:text-md mb-3 sm:mb-4">{inviteStatus}</p>
        )}
        <button
            onClick={handleInvite}
            className="w-full px-3 sm:px-4 py-2 text-white bg-charmOrange rounded-full text-base sm:text-lg"
        >
            {sendingInvite && (
                <>
                    <span
                        className="spinner-border spinner-border-sm mr-2"
                        role="status"
                        aria-hidden="true"
                    ></span>
                </>
            )}
            {sendingInvite ? 'Sending Invite...' : 'Invite'}
        </button>

        {/* Display Team Members Table */}
        {teamMembers.length > 0 && (
            <div className="mt-6 sm:mt-8 overflow-x-auto">
                <h3 className="text-lg sm:text-xl font-bold text-center text-charmHover mb-3 sm:mb-4">
                    Team Members
                </h3>
                <table className="w-full text-sm sm:text-base table-auto">
                    <thead>
                        <tr>
                            <th className="border px-2 sm:px-4 py-2">Email</th>
                            <th className="border px-2 sm:px-4 py-2">Role</th>
                        </tr>
                    </thead>
                    <tbody>
                        {teamMembers.map((member, index) => (
                            <tr key={index}>
                                <td className="border px-2 sm:px-4 py-2">{member.Email}</td>
                                <td className="border px-2 sm:px-4 py-2">
                                    {member.userRole === 'root' ? 'Admin' : 'User'}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )}
    </div>
</div>

  );
};

export default InviteTeammate;
